import IconContainer from '@/components/IconContainer'

export default function IconExclamation(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Exclamation Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.00823 2.60724C8.65378 2.60724 9.2 3.14376 9.2 3.69003C9.2 4.68287 9.13585 5.81223 9.07321 6.91494C9.03068 7.6636 8.98885 8.39998 8.96827 9.073C8.95505 9.50533 8.63458 10.0356 8.00823 10.0356C7.37827 10.0356 7.04531 9.50517 7.03168 9.073C7.01079 8.41084 6.96967 7.68528 6.92779 6.94641L6.92779 6.94639C6.86475 5.83407 6.8 4.69162 6.8 3.69003C6.8 3.14376 7.32961 2.60724 8.00823 2.60724ZM6.8 12.3181C6.8 12.9591 7.31769 13.5219 8.00785 13.5219C8.65097 13.5219 9.2 12.9591 9.2 12.3181C9.2 11.6615 8.65097 11.1144 8.00785 11.1144C7.31764 11.1144 6.8 11.6615 6.8 12.3181Z" />
    </IconContainer>
  )
}
